import React from 'react'
import Placeholder from '@/components/common/placeholder'

const MetricPlaceholder = () => {
	return <Placeholder style={{width: 270, height: 220}} />
}

export default MetricPlaceholder